// SPDX-License-Identifier: AGPL-3.0-or-later

// Generated by tools/room_themes/build_manifest.mjs from validated room ambience files. Do not edit by hand.

import type {VoiceRoomSound} from '@fluxer/constants/src/VoiceRoomSounds';
import type {VoiceRoomTheme} from '@fluxer/constants/src/VoiceRoomThemes';

export const VOICE_ROOM_AMBIENCE = {} as const satisfies Partial<Record<VoiceRoomTheme, VoiceRoomSound>>;
